// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.

export const environment = {
  production: true,
  local: true,
  mock: false,
  hmr: false,
  version: '0.0.0',
  serverBaseUrl: 'https://apiuat.bcr.ro',
  authBaseUrl: 'https://login.uat.bcr.ro',
  georgeBaseUrl: 'https://george.uat.bcr.ro',
  serverTimeout: 600,
  georgeBusinessUrl: 'https://george-business.bcr.ro',
  // serverBaseUrl: 'https://apitest.bcr.ro',
  // authBaseUrl: 'https://login.fat.bcr.ro',
  // georgeBaseUrl: 'https://george.fat.bcr.ro',
  baseHref: '/store',
  loginAction: 'https://cdg-auth-server-bcr-corporate-george-test.apps.ostst.bcr.os/login',
  defaultLanguage: 'ro-RO',
  supportedLanguages: ['en-US', 'ro-RO'],
  mocksActive: false,
  configGuard: {
    baseHref: '/corporate-george-auth',
    stateName: 'state_auth',
    clientId: 'clientId',
    cookiePath: '/',
  },
  loginCodes: {
    docheavenCOL: 'DHCOL',
    signClient: 'TPP',
    guardianrole: 'TPP',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Dateio: 'MMP',
    bcrgeorgeclient: 'GEORGE',
    georgegoclientro: 'GEORGE',
    docheaven: 'GEORGE',
    docheavenMobile: 'GEORGE',
    docheavenAD: 'GEORGE',
  },
  apiWaitTime: 3000,
};
